var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiberia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40.0001C31.0455 40.0001 39.9998 31.0458 39.9998 20.0001C39.9998 8.95437 31.0455 6.10352e-05 19.9998 6.10352e-05C8.95412 6.10352e-05 -0.000183105 8.95437 -0.000183105 20.0001C-0.000183105 31.0458 8.95412 40.0001 19.9998 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57153 7.27286H35.4284C34.2887 5.89279 32.9668 4.66896 31.5005 3.63654H8.49942C7.0331 4.6688 5.7113 5.89271 4.57153 7.27286V7.27286Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000183105 20.0001C-0.000183105 20.6131 0.0289575 21.2192 0.0829419 21.8183H39.9167C39.9707 21.2192 39.9998 20.6131 39.9998 20.0001C39.9998 19.387 39.9707 18.7809 39.9167 18.1819H0.0829419C0.0289575 18.7809 -0.000183105 19.387 -0.000183105 20.0001H-0.000183105Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.18093 29.0909H37.8191C38.408 27.9389 38.8883 26.7224 39.2469 25.4547H0.753113C1.11163 26.7224 1.5921 27.9389 2.18093 29.0909V29.0909Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49942 36.3637H31.5004C32.9668 35.3313 34.2886 34.1074 35.4283 32.7274H4.57153C5.7113 34.1073 7.0331 35.3313 8.49942 36.3637V36.3637Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.752991 14.5455H39.2469C38.8883 13.2777 38.4079 12.0611 37.819 10.9092H2.18088C1.59205 12.0611 1.11158 13.2777 0.752991 14.5455V14.5455Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56512 3.63633H31.5004C28.2473 1.34586 24.2809 0 19.9999 0C17.3912 0 12.8182 1.34586 9.56512 3.63633Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1304 10.9092H37.819C37.1539 9.60814 36.3506 8.38947 35.4283 7.27283H19.1304V10.9092Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1304 18.1819H39.9168C39.8043 16.9333 39.5782 15.7174 39.2469 14.5456H19.1304V18.1819Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.753069 25.4547H39.2468C39.5782 24.283 39.8043 23.067 39.9168 21.8184H0.0830688C0.195569 23.067 0.421663 24.2829 0.753069 25.4547V25.4547Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57147 32.7272H35.4283C36.3506 31.6104 37.1539 30.3918 37.819 29.0909H2.18085C2.84593 30.3919 3.64921 31.6106 4.57147 32.7272V32.7272Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 40C24.2809 40 28.2474 38.6542 31.5005 36.3637H8.49939C11.7525 38.6542 15.7189 40 19.9999 40Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.752991 14.5455C0.421584 15.7173 0.195569 16.9332 0.0830688 18.1818H19.9999V0C10.8453 0 3.12737 6.15094 0.752991 14.5455V14.5455Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9052 5.21747L13.2002 9.20301H17.3912L14.0008 11.6665L15.2956 15.6522L11.9052 13.189L8.51468 15.6522L9.80984 11.6665L6.41937 9.20301H10.6102L11.9052 5.21747Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiberia);
export default __webpack_public_path__ + "static/media/liberia.780eb740e769c0532360e3f30ef6fff3.svg";
export { ForwardRef as ReactComponent };